<template>
  <div v-if="!isEmptyAnswer" class="resume-documents__group">
    <div class="resume-documents__head">
      <span class="resume-documents__head-title">{{ $get(item, 'question') }}</span>

      <div class="d-flex justify-between">
        <ResumeDocumentsGroupFiles
          v-if="item.type === 'image' && item.answer"
          :files="Array.isArray(item.answer) ? item.answer : [item.answer]"
          class="resume-documents__group-files"
        />

        <div v-else-if="typeof item.answer === 'object'">
          <template v-if="isArrayWithPlainData(item.answer)">
            <div
              v-for="(item, index) in item.answer"
              :key="index"
              class="resume-documents__head-subtitle"
            >
              {{ item }}{{ JSON.stringify(item.answer, null, 2) }}
            </div>
          </template>

          <component v-else :is="customAnswerComponent" :answer="item.answer">
            {{ JSON.stringify(item.answer, null, 2) }}
          </component>
        </div>

        <span v-else class="resume-documents__head-subtitle">{{ getAnswer }} </span>

        <button
          v-if="showEditButton"
          class="base-btn resume-documents__edit-btn"
          @click="editQuestion"
        >
          <BaseSvg name="ico-edit" width="1.2rem" height="1.2rem" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import {AGENT, EMPLOYER, PARTNER} from '../../constants/usersTypes';
  import ResumeDocumentsGroupFiles from './ResumeDocumentsGroupFiles'

  const CustomAnswerType = {
    WORK_EXPERIENCE: 'WORK_EXPERIENCE',
    CERTIFICATES: 'CERTIFICATES',
    LANGUAGES: 'LANGUAGES',
  };

  export default {
    name: 'ResumeDocumentsGroup',
    components: {
      ResumeDocumentsGroupFiles,
    },
    props: ['item', 'resume'],
    computed: {
      ...mapGetters('user', [
        'userType',
      ]),

      getAnswer() {
        if (this.$get(this.item, 'type') === 'bool') {
          if (this.$get(this.item, 'answer')) {
            return 'ТАК';
          } else {
            return 'НІ';
          }
        }
        return this.$get(this.item, 'answer');
      },
      isEmptyAnswer() {
        return !this.item.answer || (Array.isArray(this.item.answer) && !this.item.answer.length);
      },
      customAnswerComponent() {
        switch (this.defineCustomAnswerType()) {
          case CustomAnswerType.WORK_EXPERIENCE: return () => import('./custom-question-answers/WorkExperienceAnswer');
          case CustomAnswerType.CERTIFICATES: return () => import('./custom-question-answers/CertificatesAnswer');
          case CustomAnswerType.LANGUAGES: return () => import('./custom-question-answers/LanguagesAnswer');
          default: return 'pre';
        }
      },
      showEditButton() {
        return this.item.can_edit && [EMPLOYER, AGENT, PARTNER].includes(this.userType);
      },
    },
    methods: {
      isArrayWithPlainData(data) {
        if (!Array.isArray(data)) return false;
        return data.every(el => typeof el !== 'object');
      },
      defineCustomAnswerType() {
        const { answer } = this.item;
        const isArray = Array.isArray(answer);

        if (isArray && answer.every(el => (el.specialization || el.term))) return CustomAnswerType.WORK_EXPERIENCE;
        if (Array.isArray(answer.files) && answer.show_status) return CustomAnswerType.CERTIFICATES;
        if (isArray && answer.every(el => el.lang)) return CustomAnswerType.LANGUAGES;

        return null;
      },
      editQuestion() {
        this.$vModal.open('edit-additional-question-answer', {
          resumeId: this.resume.resume_id,
          questionId: this.item.question_id,
          onUpdate: this.onEditUpdate,
        });
      },
      onEditUpdate(value) {
        if (Array.isArray(value)) {
          this.item.answer = value[0]?.path || null;
          return;
        }
        this.item.answer = value;
      },
    },
  }
</script>
